import React from 'react';
import FullSection from '../FullSection';
import SectionTitle from '../SectionTitle';
import styles from './Grid.module.css';

export default ({
  columns, mobileColumns, children, backgroundColor, className, title, titleSize,
}) => (
  <FullSection style={{ backgroundColor }} className={className}>
    {title && (
      <div className={styles.title}>
        <SectionTitle size={titleSize}>{title}</SectionTitle>
      </div>
    )}
    <div
      className={styles.grid}
      style={{
        '--columns': columns || 1,
        '--mobileColumns': mobileColumns || 2,
      }}
    >
      {children}
    </div>
  </FullSection>
);
